import { render, staticRenderFns } from "./SessionHistory.vue?vue&type=template&id=27359899&scoped=true&"
import script from "./SessionHistory.vue?vue&type=script&lang=js&"
export * from "./SessionHistory.vue?vue&type=script&lang=js&"
import style0 from "./SessionsHistory.css?vue&type=style&index=0&id=27359899&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27359899",
  null
  
)

export default component.exports